import { Link } from "react-router-dom";
import { NumberCard } from "../cards/NumberCard";

interface NumberCardType {
  numberCards: {
    number: string;
    title: string;
    text: string;
  }[];
  sectionTitle: string;
  sectionText: string;
}

function NumberCardsComponent({
  numberCards,
  sectionTitle,
  sectionText
}: NumberCardType) {
  return (
    <div className="p-4 lg:p-16 bg-[#E9EFF5] flex flex-col-reverse lg:flex-row lg:justify-between ">
      <div className="w-full lg:w-2/5">
        {numberCards.map((el, index) => (
          <NumberCard
            key={index}
            number={el.number}
            title={el.title}
            text={el.text}
          />
        ))}
      </div>
      <div className="flex text-center mb-6 lg:w-2/5 flex-col lg:justify-center lg:text-start">
        <h3 className="mb-6 text-2xl font-semibold">{sectionTitle}</h3>
        <p className="mb-6 text-[#1A2835]">{sectionText}</p>
        <div>
          <Link
            className="bg-[#1672EC] text-white px-4 py-2 rounded-md"
            to="/register"
          >
            Get started
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NumberCardsComponent;
